import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Projects/Nearby/tables";
import headers from "../../../../Data/Tables/Projects/Nearby/headers";
import { get_all_project_nearbies } from "../../../../Controllers/Projects/Nearby";
import Loadercomponent from "../../../../Components/Loader";
import Table from "../../../../Components/Table";
import Header from "../../../../Components/Header";
import ActionButton from "../../../../Components/Buttons/action";
import TableImage from "../../../../Components/Tableimage";
import Status from "../../../../Components/Status";

const ProjectNearbyTable = () => {
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();

  const formdata = (data) => {
    fetchData(data);
  };

  const actiondata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        status: tabledata?.status,
      };

      const nearbies = await get_all_project_nearbies(params);

      if (nearbies?.status) {
        let data = [];

        nearbies?.data?.map((value, index) => {
          data?.push({
            Name: value?.name,
            Status: <Status status={value?.status} />,
            Action: (
              <ActionButton
                edit={`/app/projects/nearby/edit/${value?._id}`}
                id={value?._id}
                api="delete-project-nearby"
                actiondata={actiondata}
              />
            ),
          });
        });

        setBody(data);
        setLoader(false);
      } else {
        toast?.error(nearbies?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={headers} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Table head={tables} body={body} />
      </Loadercomponent>
    </Header>
  );
};

export default ProjectNearbyTable;
